import { NgModule, Pipe, PipeTransform } from '@angular/core';

function isArray(value) {
  return value instanceof Array;
}

function isFunction(value) {
  return value instanceof Function;
}

function isString(value) {
  return value instanceof String;
}

function isObject(value) {
  return value instanceof Object;
}

function processPredicates(sortPredicates) {
  return sortPredicates.map(function (predicate) {
    let descending = 1;
    let get: any = function (i) {
      return i[predicate];
    };

    if (isFunction(predicate)) {
      get = predicate;
    } else if (isString(predicate)) {
      if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
        descending = predicate.charAt(0) === '-' ? -1 : 1;
        predicate = predicate.substring(1);
      }
      if (predicate !== '') {
        // get = $parse(predicate);
        if (get.constant) {
          const key = get();
          get = function (value) { return value[key]; };
        }
      }
    }
    return { get: get, descending: descending };
  });
}

function isPrimitive(value) {
  switch (typeof value) {
    case 'number': /* falls through */
    case 'boolean': /* falls through */
    case 'string':
      return true;
    default:
      return false;
  }
}

function objectValue(value) {
  if (isFunction(value.valueOf)) {
    value = value.valueOf();
    if (isPrimitive(value)) {
      return value;
    }
  }
  if (hasCustomToString(value)) {
    value = value.toString();
    if (isPrimitive(value)) {
      return value;
    }
  }

  return value;
}

function hasCustomToString(obj) {
  return isFunction(obj.toString) && obj.toString !== toString;
}

function getPredicateValue(value, index) {
  let type = typeof value;
  if (value === null) {
    type = 'null' as typeof value;
  } else if (type === 'object') {
    value = objectValue(value);
  }
  return { value: value, type: type, index: index };
}

function defaultCompare(v1, v2) {
  let result = 0;
  const type1 = v1.type;
  const type2 = v2.type;

  if (type1 === type2) {
    let value1 = v1.value;
    let value2 = v2.value;

    if (type1 === 'string') {
      value1 = value1.toLowerCase();
      value2 = value2.toLowerCase();
    } else if (type1 === 'object') {
      if (isObject(value1)) {
        value1 = v1.index;
      }
      if (isObject(value2)) {
        value2 = v2.index;
      }
    }

    if (value1 !== value2) {
      result = value1 < value2 ? -1 : 1;
    }
  } else {
    result = (type1 === 'undefined') ? 1 :
      (type2 === 'undefined') ? -1 :
        (type1 === 'null') ? 1 :
          (type2 === 'null') ? -1 :
            (type1 < type2) ? -1 : 1;
  }

  return result;
}

@Pipe({
  name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {

  transform(array: any[], sortPredicate?: any, reverseOrder?: boolean): any[] {

    if (array == null) {
      return array;
    }

    if (!isArray(sortPredicate)) {
      sortPredicate = [sortPredicate];
    }
    if (sortPredicate.length === 0) {
      sortPredicate = ['+'];
    }

    const predicates = processPredicates(sortPredicate);
    const descending = reverseOrder ? -1 : 1;
    const compare = defaultCompare;
    const compareValues = Array.prototype.map.call(array, getComparisonObject);
    compareValues.sort(doComparison);
    array = compareValues.map(function (item) { return item.value; });

    return array;

    function getComparisonObject(value, index) {
      return {
        value: value,
        tieBreaker: { value: index, type: 'number', index: index },
        predicateValues: predicates.map(function (predicate) {
          return getPredicateValue(predicate.get(value), index);
        })
      };
    }

    function doComparison(v1, v2) {
      for (let i = 0, ii = predicates.length; i < ii; i++) {
        const result = compare(v1.predicateValues[i], v2.predicateValues[i]);
        if (result) {
          return result * predicates[i].descending * descending;
        }
      }

      return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
    }
  }

}

@NgModule({
  imports: [],
  declarations: [OrderByPipe],
  exports: [OrderByPipe]
})
export class OrderByPipeModule { }
